import React from "react";
import { ChevronLeft } from "lucide-react";
import ReservationPanel from "./ReservationPanel";

const ReservationColumn = ({
  mobileSectionShown,
  setMobileSectionShown,
  reservation,
}) => (
  <div
    className={`${mobileSectionShown === "reservation" ? "flex" : "hidden"} lg:flex w-full lg:w-72 lg:flex-shrink-0 border-l border-gray-200 dark:border-gray-700 bg-[#ffffff] dark:bg-darkBg1 flex-col overflow-hidden`}
  >
    <div className="flex items-center gap-2 px-3 md:px-4 py-2 md:py-3 border-b border-gray-200 dark:border-gray-700">
      <button
        onClick={() => setMobileSectionShown("messages")}
        className="flex lg:hidden items-center justify-center w-7 h-7 md:w-8 md:h-8 rounded-full bg-gray-200 dark:bg-gray-600 hover:bg-gray-300 dark:hover:bg-gray-500 flex-shrink-0"
      >
        <ChevronLeft size={16} />
      </button>
      <h6 className="font-semibold text-xs md:text-sm dark:text-white">
        Reservation Details
      </h6>
    </div>
    <div className="flex-1 overflow-y-auto">
      <ReservationPanel reservation={reservation} />
    </div>
  </div>
);

export default ReservationColumn;
